import { render, staticRenderFns } from "./certs-modal.vue?vue&type=template&id=6e8baafe&"
import script from "./certs-modal.vue?vue&type=script&lang=js&"
export * from "./certs-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports